import { SITE } from "@/lib/site";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-brand-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 reveal">
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div
              aria-hidden
              className="absolute inset-0 translate-x-5 translate-y-5 rounded-[36px] bg-brand-gold/40"
            />
            <div className="relative overflow-hidden rounded-[36px] bg-brand-coral">
              <img
                src={SITE.aboutPhotoUrl}
                alt="Noa Grant"
                data-testid="about-portrait"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <span className="text-xs md:text-sm uppercase tracking-[0.28em] text-brand-coral font-semibold">
            About Noa
          </span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl lg:text-6xl text-brand-navy leading-[1.05] tracking-tight">
            You don't have to navigate ADHD alone.
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-brand-navy/75">
            I help adults and parents turn strengths into systems that work.
            Together we'll create a plan that lets your gifts shine while
            reducing friction in a neurotypical world.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-brand-navy/75">
            A strong partnership needs trust, curiosity, clear goals, mutual
            respect, and a willingness to try new things, and laugh when plans
            go sideways. That's the kind of coaching I bring.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={SITE.calendly}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="about-cta-calendly"
              className="inline-flex items-center justify-center rounded-full bg-brand-navy text-brand-cream px-8 py-4 text-sm md:text-base font-medium hover:bg-brand-coral transition-colors duration-300"
            >
              Book a Free Discovery Call
            </a>
            <a
              href="#contact"
              data-testid="about-cta-contact"
              className="inline-flex items-center justify-center rounded-full border border-brand-sageDeep/30 text-brand-sageDeep px-8 py-4 text-sm md:text-base font-medium hover:border-brand-sageDeep hover:bg-white/60 transition"
            >
              Send a Message
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
